module.exports = __webpack_public_path__ + "static/media/workingmemory-words-5.ebae0647.mp3";